import React from 'react'
import { useParams } from 'react-router-dom'
import { salesData } from '../data/salesData' // Aapka path adjust kar lena

import WhoHero from '../Components/who/WhoHero'
import EmpowerSection from '../Components/sales/EmpowerSection'
import SalesforceServices from '../Components/sales/SalesforceServices'
import WhyChooseUs from '../Components/sales/WhyChooseUs'
import IndustriesServe from '../Components/sales/IndustriesServe'
import TrustSection from '../Components/sales/TrustSection'
import ProcessSection from '../Components/sales/ProcessSection'
import AccContact from '../Components/Accelerating/AccContact'
import { Helmet } from "react-helmet-async";

function SalesServices() {
    const { slug } = useParams();

    const pageData = salesData.find(page => page.slug === `/${slug}`);

    if (!pageData) {
        return (
            <div className="w-full h-screen flex items-center justify-center text-2xl font-bold text-[#01386A]">
                Page Not Found
            </div>
        );
    }

    return (
        <div>
            <Helmet>
    <title>
        {pageData.hero.title} | Salesforce Services | Mobikode
    </title>

    <meta
        name="description"
        content={`${pageData.hero.text} Mobikode provides Salesforce consulting, implementation, customization, integration, and digital transformation services for businesses.`}
    />

    <meta
        name="keywords"
        content="Salesforce Services, Salesforce Consulting, Salesforce Consultant, Salesforce Implementation, Salesforce Integration, Salesforce Customization, Salesforce Development, Salesforce Solutions, Salesforce CRM Services, Salesforce Development Services, Salesforce Consulting Services, Salesforce Digital Transformation, Salesforce Partner, Salesforce Experts, Mobikode"
    />

    <link
        rel="canonical"
        href={`https://www.mobikode.com/${slug}`}
    />

    <meta
        property="og:title"
        content={`${pageData.hero.title} | Salesforce Services | Mobikode`}
    />

    <meta
        property="og:description"
        content={`${pageData.hero.text} Discover tailored Salesforce consulting, implementation, integration, and development solutions from Mobikode.`}
    />

    <meta
        property="og:url"
        content={`https://www.mobikode.com/${slug}`}
    />

    <meta
        property="og:type"
        content="website"
    />

    <meta
        property="og:image"
        content={`https://www.mobikode.com${pageData.hero.imgData}`}
    />

    <meta
        name="twitter:card"
        content="summary_large_image"
    />

    <meta
        name="twitter:title"
        content={`${pageData.hero.title} | Salesforce Services | Mobikode`}
    />

    <meta
        name="twitter:description"
        content={`${pageData.hero.text} Get scalable Salesforce consulting and implementation solutions from Mobikode.`}
    />

    <meta
        name="twitter:image"
        content={`https://www.mobikode.com${pageData.hero.imgData}`}
    />
</Helmet>
            {/* Hero Section */}
            <WhoHero
                title={pageData.hero.title}
                text={pageData.hero.text}
                imgData={pageData.hero.imgData}
            />

            <EmpowerSection data={pageData.empower} />
            <SalesforceServices data={pageData.servicesCarousel} />
            <WhyChooseUs data={pageData.whyChooseUs} />
            <IndustriesServe data={pageData.industriesServe} />
            <TrustSection data={pageData.trustSection} />
            <ProcessSection data={pageData.processSection} />
            <section className='relative'>
                <img src="/assets/what/item16.png" className='lg:h-[683px] h-[800px] w-full object-cover' alt="" />
                <div className="max-w-[1440px] w-full mx-auto lg:px-[80px] px-[20px] top-1/2 -translate-y-1/2 absolute left-1/2 -translate-x-1/2">
                    <AccContact />
                </div>
            </section>
        </div>
    )
}

export default SalesServices